import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const { Currency } = window['runConfig'];

const useStyles = makeStyles((theme) => ({
  root: {
    // '& > *': {
    //   margin: theme.spacing(1),
    // },
    display: "unset"
  }
}));


function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix={Currency}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function FormattedInputs(props) {
  const classes = useStyles();
  const [values, setValues] = React.useState({
    amountExceed: false
  });

  const handleChange = (event) => {

    if (parseFloat(event.target.value) < props.minValue || parseFloat(event.target.value) > props.maxValue) {
      setValues({ ...values, amountExceed: true });
      props.Validated(false);
    }
    else {
      props.Validated(true);
      setValues({ ...values, amountExceed: false });
    }

    props.handleOtherPrice(event);
  }

  return (
    <div className={classes.root}>
      <TextField
        error={values.amountExceed}
        label={props.label ? props.label : (Currency + '' + props.minValue) + ' - ' + (Currency + '' + props.maxValue)}
        onChange={handleChange}
        name={props.productName}
        value={props.donaValue}
        key={props.keyvalue}
        variant={props.variant}
        size={props.size}
        disabled={props.disabled}
        id="formatted-numberformat-input"
        InputProps={{
          inputComponent: NumberFormatCustom,
        }}
        inputProps={{
          "data-hj-allow": ""
        }}
      />
    </div>
  );
}
